<template>
  <div class="tvController">
    <div class="frame">
      <!-- <div class="ctrlColumn">
        <div class="vol btns">
          <span class="label">VOL</span>
          <button type="button" class="btnCtrl" @click="remoteTv('volup')"><i>&#43;</i></button>
          <button type="button" class="btnCtrl" @click="remoteTv('voldown')"><i>&#8722;</i></button>
          <button type="button" class="mute" @click="remoteTv('mute')"><img src="@/assets/img/ico_speaker.png" alt="mute" /></button>
        </div>
        <div class="tvInput btns">
          <button class="btnPower" @click="remoteTv('power')"></button>
          <button class="btnCtrl btnExt" @click="remoteTv('input')">{{locale.tvcontrol_ext}}</button>
        </div>
        <div class="ch btns">
          <span class="label">CH</span>
          <button type="button" class="btnCtrl" @click="remoteTv('chanup')"><i>&#10094;</i></button>
          <button type="button" class="btnCtrl" @click="remoteTv('chandown')"><i>&#10095;</i></button>
        </div>
      </div>
      <div class="arr btns">
        <div class="group">
          <button type="button" class="btnCtrl up" @click="remoteTv('navigate_up')"><i>&#10094;</i></button>
          <button type="button" class="btnCtrl right" @click="remoteTv('navigate_right')"><i>&#10095;</i></button>
          <button type="button" class="btnCtrl left" @click="remoteTv('navigate_left')"><i>&#10094;</i></button>
          <button type="button" class="btnCtrl down" @click="remoteTv('navigate_down')"><i>&#10095;</i></button>
        </div>
        <button type="button" class="btnCtrl btnOk" @click="remoteTv('ok')">OK</button>
        <button type="button" class="btnCtrl btnMenu" @click="remoteTv('menu')">MENU</button>
        <button type="button" class="btnCtrl btnExit" @click="remoteTv('exit')">EXIT</button>
      </div> -->
      <div v-if="remoteSetting.remocon && remoteButton.length > 0" class="activeRemote">
        <template
          v-for="button in remoteButton">
          <div v-if="button.id.includes('default_controls')" :key="button.id" class="ctrlGroup">
            <div class="ctrlColumn">
              <div class="vol btns">
                <span class="label">VOL</span>
                <button type="button" class="btnCtrl" @click="remoteTv('volup')"><i>&#43;</i></button>
                <button type="button" class="btnCtrl" @click="remoteTv('voldown')"><i>&#8722;</i></button>
                <button type="button" class="mute" @click="remoteTv('mute')"><img src="@/assets/img/ico_speaker.png" alt="mute" /></button>
              </div>
              <div class="tvInput btns">
                <button class="btnPower" @click="remoteTv('power')"></button>
                <button class="btnCtrl btnExt" @click="remoteTv('input')">{{locale.tvcontrol_ext}}</button>
              </div>
              <div class="ch btns">
                <span class="label">CH</span>
                <button type="button" class="btnCtrl" @click="remoteTv('chanup')"><i>&#10094;</i></button>
                <button type="button" class="btnCtrl" @click="remoteTv('chandown')"><i>&#10095;</i></button>
              </div>
            </div>
          </div>
          <div v-else-if="button.id.includes('default_arrows')" :key="button.id" class="arrGroup">
            <div class="arr btns">
              <div class="group">
                <button type="button" class="btnCtrl up" @click="remoteTv('navigate_up')"><i>&#10094;</i></button>
                <button type="button" class="btnCtrl right" @click="remoteTv('navigate_right')"><i>&#10095;</i></button>
                <button type="button" class="btnCtrl left" @click="remoteTv('navigate_left')"><i>&#10094;</i></button>
                <button type="button" class="btnCtrl down" @click="remoteTv('navigate_down')"><i>&#10095;</i></button>
              </div>
              <button type="button" class="btnCtrl btnOk" @click="remoteTv('ok')">OK</button>
              <button type="button" class="btnCtrl btnMenu" @click="remoteTv('menu')">MENU</button>
              <button type="button" class="btnCtrl btnExit" @click="remoteTv('exit')">EXIT</button>
            </div>
          </div>
          <button v-else type="button" class="btnCtrl"
            :key="button.id"
            :class="{
              remoteEmpty: remoteEmpty(button.id),
              remoteGroup: remoteGroup(button.id),
              remoteColor: remoteColor(button.id)
            }"
            :data-button="button.id"
            @click="remoteTv(button.id)">
            <img v-if="remoteIcon.includes(button.id)" :src="getIcon(button.id)" :alt="button.id" />
            <span v-else>{{button.name}}</span>
          </button>
        </template>
        <!-- <button type="button" class="btnCtrl"
          v-for="button in remoteButton"
          :key="button.id"
          :class="{
            remoteEmpty: remoteEmpty(button.id),
            remoteGroup: remoteGroup(button.id),
            remoteColor: remoteColor(button.id)
          }"
          :data-button="button.id"
          @click="remoteTv(button.id)">
          <img v-if="remoteIcon.includes(button.id)" :src="getIcon(button.id)" :alt="button.id" />
          <span v-else>{{button.name}}</span>
        </button> -->
      </div>
      <!--
      <div class="num">
        <button type="button" class="btnCtrl"
          v-for="num in numbers"
          :key="num"
          @click="remoteTv(num)">
          {{num}}
        </button>
      </div>
       -->
    </div>
    <TvLoading v-if="isTvLoading" />
  </div>
</template>

<script>
import TvLoading from '@/components/TvControl/TvLoading'

export default {
  name: 'Controller',
  props: [
    'lang',
    'locale',
    'roomKey',
    'tvIndex'
  ],
  components: {
    TvLoading
  },
  computed: {
    partner () {
      return this.$store.state.system.partner.name
    },
    remoteSetting () {
      return this.$store.getters['tv/getSetting']
    },
    remoteIcon () {
      return this.remoteSetting.remoteIcon || []
    },
    remoteButton () {
      const setting = this.remoteSetting
      const remoteList = setting && setting.remoteList ? setting.remoteList : []
      return remoteList
    },
    numbers () {
      const num = this.partner === 'CoreGuide' ? [10, 11, 12] : [0]
      return this.number.concat(num)
    }
  },
  created () {
  },
  data () {
    return {
      isTvLoading: false,
      colors: [
        'red',
        'blue',
        'yellow',
        'green'
      ],
      number: [
        1, 2, 3, 4, 5, 6, 7, 8, 9
      ]
    }
  },
  methods: {
    getNum (num) {
      return num === 10 ? 0 : num
    },
    remoteEmpty (id) {
      return id.includes('remote_empty')
    },
    remoteGroup (id) {
      return id.includes('remote_group')
    },
    remoteColor (id) {
      const colors = this.colors
      return colors.includes(id)
    },
    getIcon (id) {
      const img = id.replace(/(\s*)/g, '')
      return require(`@/assets/img/tvcontroller/ico_${img}.png`)
    },
    remoteTv (cmd) {
      const data = {
        cmd: cmd,
        tv: this.tvIndex,
        type: 'button'
      }
      this.isTvLoading = true
      this.$store.dispatch('tv/setTvControl', data).then((res) => {
        this.isTvLoading = false
        if (res.data && res.data.status === 403) {
          const message = res.data.message.includes('notSupported')
            ? 'notSupported'
            : res.data.message.includes('fail')
              ? 'fail'
              : 'fail'
          this.$emit('toast', message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$color-btn: #32323a;

.tvController {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-top: 45px;
  font-family: 'Pretendard', 'Noto Sans', 'Kosugi Maru', 'Noto Sans SC', 'Noto Sans KR', 'sans-serif';
  color: $color-white;
  background-color: rgba(0,0,0,0.7);
  z-index: 998;
}
.frame {
  flex: 1;
  width: 100%;
  max-width: 400px;
  overflow: auto;
  margin: 30px 15px;;
  padding: 30px 30px 60px;
  border-radius: 8px;
  background-color: #1a1c1d;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
}
.ctrlGroup {
  width: 100%;
}
.ctrlColumn {
  text-align: center;
}
.vol,
.ch,
.tvInput {
  display: inline-block;
  vertical-align: top;
  width: 30%;
  max-width: 20%;
}
.vol,
.ch {
  position: relative;
  .label {
    font-size: 0.8em;
  }
  .btnCtrl {
    flex: none;
    width: 100%;
    height: 60px;
    font-size: 1.8em;
    i {
      position: relative;
    }
  }
  .mute {
    width: 100%;
    margin-top: 10px;
    padding: 8px 0;
    img {
      height: 24px;
      opacity: 0.5;
    }
  }
}
.vol i {
  top: -0.1em;
}
.ch i {
  display: inline-block;
  top: -0.25em;
  left: 0.1em;
  font-size: 0.7em;
  transform: rotate(90deg);
}
.tvInput {
  max-width: 30%;
  margin: 30px 30px 0;
  align-items: center;
  .btnCtrl {
    width: 100%;
    height: auto;
    margin-top: 10px;
    padding: 0.5em 0;
    font-size: 0.8em;
  }
  .btnPower {
    position: relative;
    width: 100%;
    height: 60px;
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 40px;
      border-radius: 100%;
      border: 6px solid $color-white;
      transform: translate(-50%, -50%);
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 6px;
      height: 30px;
      margin-top: -15px;
      border-radius: 10px;
      border: 6px solid #1a1c1d;
      background-color: $color-red;
      transform: translate(-50%, -50%);
    }
    &:active {
      &:before {
        border-color: #19e4e4;
      }
      &:after {
        background-color: $color-white;
      }
    }
  }
}
.arrGroup {
  width: 100%;
  padding: 40px 0 50px;
}
.arr {
  position: relative;
  width: 160px;
  margin: 0 auto;
  text-align: center;
  .group {
    transform: rotate(45deg);
  }
  .btnCtrl {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0;
    padding: 0;
    border: 1px solid #1a1c1d;
    i {
      display: inline-block;
      position: relative;
    }
  }
  .btnOk {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 80px;
    border-radius: 2px;
    background-color: #1a1c1d;
    box-shadow: inset 0 0 5px rgba(0,0,0,0.5);
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .btnMenu {
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 80px;
    height: auto;
    margin-bottom: -35px;
    padding: 0.5em 0;
    font-size: 0.8em;
  }
  .btnExit {
    position: absolute;
    bottom: 0;
    left: 100%;
    width: 80px;
    height: auto;
    margin-bottom: -35px;
    padding: 0.5em 0;
    font-size: 0.8em;
  }
  .up i {
    top: -20px;
    left: -20px;
    transform: rotate(45deg);
  }
  .down i {
    bottom: -20px;
    right: -20px;
    transform: rotate(45deg);
  }
  .left i {
    bottom: -20px;
    left: -20px;
    transform: rotate(-45deg);
  }
  .right i {
    top: -20px;
    right: -20px;
    transform: rotate(-45deg);
  }
}
.num {
  flex-wrap: wrap;
  text-align: center;
  .btnCtrl {
    width: calc(33.33% - 2px);
  }
}
.btnCtrl {
  height: 50px;
  margin: 1px;
  padding: 0;
  font-size: 1.4em;
  border-radius: 2px;
  background-color: $color-btn;
  &:active {
    color: #19e4e4;
    box-shadow: inset 0 0 5px 2px rgba(0,0,0,0.3);
  }
}
.activeRemote {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 25px;
  justify-content: center;
  text-align: center;
  .btnCtrl {
    flex: auto;
    font-size: 1em;
    img {
      height: 20px;
    }
  }
  .remoteEmpty {
    width: 100%;
    height: 15px;
    margin: 0;
    font-size: 0;
    background: none;
    box-shadow: none;
    opacity: 0;
    z-index: -1;
  }
  .remoteGroup {
    flex: none;
    width: 100%;
    height: 0;
    margin: 0;
    font-size: 0;
  }
  .remoteColor {
    position: relative;
    font-size: 0;
    text-indent: -9999px;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 16px;
      height: 16px;
      margin-top: -8px;
      margin-left: -8px;
      border-radius: 100%;
      box-shadow: 0 0 5px rgba(0,0,0,0.5);
    }
    &[data-button="red"]:before {
      background-color: #dc3746;
    }
    &[data-button="green"]:before {
      background-color: #72b333;
    }
    &[data-button="blue"]:before {
      background-color: #238fce;
    }
    &[data-button="yellow"]:before {
      background-color: #e4cc2c;
    }
  }
}
@media (min-width: 768px) {
  .tvController {
    padding-top: 75px;
    padding-bottom: 30px;
  }
}
</style>
